// create
export const CREATE_RAMIS_MAJOR_GROUP_REQUEST = "CREATE_RAMIS_MAJOR_GROUP_REQUEST";
export const CREATE_RAMIS_MAJOR_GROUP_SUCCESS = "CREATE_RAMIS_MAJOR_GROUP_SUCCESS";
export const CREATE_RAMIS_MAJOR_GROUP_FAIL = "CREATE_RAMIS_MAJOR_GROUP_FAIL";

// get
export const RAMIS_MAJOR_GROUP_REQUEST = "RAMIS_MAJOR_GROUP_REQUEST";
export const RAMIS_MAJOR_GROUP_SUCCESS = "RAMIS_MAJOR_GROUP_SUCCESS";
export const RAMIS_MAJOR_GROUP_FAIL = "RAMIS_MAJOR_GROUP_FAIL";

// find
export const FIND_RAMIS_MAJOR_GROUP_REQUEST = "FIND_RAMIS_MAJOR_GROUP_REQUEST";
export const FIND_RAMIS_MAJOR_GROUP_SUCCESS = "FIND_RAMIS_MAJOR_GROUP_SUCCESS";
export const FIND_RAMIS_MAJOR_GROUP_FAIL = "FIND_RAMIS_MAJOR_GROUP_FAIL";

// update
export const UPDATE_RAMIS_MAJOR_GROUP_REQUEST = "UPDATE_RAMIS_MAJOR_GROUP_REQUEST";
export const UPDATE_RAMIS_MAJOR_GROUP_SUCCESS = "UPDATE_RAMIS_MAJOR_GROUP_SUCCESS";
export const UPDATE_RAMIS_MAJOR_GROUP_FAIL = "UPDATE_RAMIS_MAJOR_GROUP_FAIL";

// delete
export const DELETE_RAMIS_MAJOR_GROUP_REQUEST = "DELETE_RAMIS_MAJOR_GROUP_REQUEST";
export const DELETE_RAMIS_MAJOR_GROUP_SUCCESS = "DELETE_RAMIS_MAJOR_GROUP_SUCCESS";
export const DELETE_RAMIS_MAJOR_GROUP_FAIL = "DELETE_RAMIS_MAJOR_GROUP_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";
